import { render } from "./FloatingQuickMenu.vue?vue&type=template&id=5c526bea&scoped=true"
import script from "./FloatingQuickMenu.vue?vue&type=script&lang=js"
export * from "./FloatingQuickMenu.vue?vue&type=script&lang=js"

import "./FloatingQuickMenu.vue?vue&type=style&index=0&id=5c526bea&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c526bea"]])

export default __exports__